import React from 'react';
import { FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';

const UserWarningBadge = ({ warnings }) => {
  if (!warnings) {
    return null;
  }

  return (
    <div className="flex items-center gap-1 ml-2">
      {warnings.hasYellow && (
        <div className="tooltip tooltip-top" data-tip="Gelbe Karte - Posting beschränkt">
          <span className="badge badge-warning badge-sm text-white">
            <FaExclamationTriangle className="w-2.5 h-2.5" />
          </span>
        </div>
      )}
      {warnings.hasRed && (
        <div className="tooltip tooltip-top" data-tip="Rote Karte - Gesperrt">
          <span className="badge badge-error badge-sm text-white">
            <FaTimesCircle className="w-2.5 h-2.5" />
          </span>
        </div>
      )}
    </div>
  );
};

export default UserWarningBadge;
